var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.835 11.073c.235-.239.617-.239.853 0l5.199 5.26 2.715-2.747h.705c1.671 0 3.026-1.372 3.026-3.063V6.396c0-1.692-1.355-3.063-3.026-3.063H5.027C3.356 3.333 2 4.704 2 6.396v4.127c0 1.691 1.356 3.063 3.027 3.063h2.44l-1.632-1.65c-.235-.239-.235-.625 0-.863",
    transform: "translate(-251 -793) translate(251 793)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledSpeechBubble);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-speech-bubble.75c42cefb4bb31fc6698745e62759503.svg";
export { ForwardRef as ReactComponent };